
angular.module('homebot.filters', [])
  .filter('titlecase', function() {
    return _.startCase;
  })

  .filter('phone', function(){
    return function(str){
      str = str || '';
      str = str.toString().replace(/[^0-9]/g, '');

      if(!str || str.length < 9)
        return '';

      if(str.slice(0,1) === '1')
        str = str.slice(1);

      return str.slice(0,3) + '-' + str.slice(3,6) + '-' + str.slice(6);
    };
  })

  .filter('mobile', function(){
    return function(phones){
      if(!phones || !phones.length) return '';
      var mobile = _.filter(phones,{which:'mobile'});
      if(!mobile || !mobile.length) return '';

      return mobile[0].number || '';
    };
  })

  .filter('allToDashes', function(){
    return function(str){
      return str.replace(/[^0-9A-Z]/ig, '-');
    }
  })

  .filter('moment', function(){
    return function(datetime, format){
      if(datetime === 'now') datetime = new Date();
      datetime = datetime || moment.invalid();
      return moment(datetime).format(format);
    }
  })

  .filter('fromNow', function(){
    return function(datetime, format){
      return moment(datetime).fromNow();
    }
  })

  .filter('fromNowUTC', function(){
    return function(datetime, format){
      return moment.utc(datetime).fromNow();
    }
  })

  .filter('abs', function(){
    return function(val){
      return Math.abs(val);
    }
  })

  .filter('roundRate', function(){
    return function(val){
      return Math.ceil(val * 8) / 8;
    }
  })


  .filter('numberToWords', function(){
    return function(val){
      val = parseInt(val);
      var numbers = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
      return numbers[val];
    }
  })

  .filter('stateAbbrToName', function(){
    return function(val){
      const states = {
        "AL": "Alabama",
        "AK": "Alaska",
        "AS": "American Samoa",
        "AZ": "Arizona",
        "AR": "Arkansas",
        "CA": "California",
        "CO": "Colorado",
        "CT": "Connecticut",
        "DE": "Delaware",
        "DC": "District Of Columbia",
        "FL": "Florida",
        "GA": "Georgia",
        "GU": "Guam",
        "HI": "Hawaii",
        "ID": "Idaho",
        "IL": "Illinois",
        "IN": "Indiana",
        "IA": "Iowa",
        "KS": "Kansas",
        "KY": "Kentucky",
        "LA": "Louisiana",
        "ME": "Maine",
        "MH": "Marshall Islands",
        "MD": "Maryland",
        "MA": "Massachusetts",
        "MI": "Michigan",
        "MN": "Minnesota",
        "MS": "Mississippi",
        "MO": "Missouri",
        "MT": "Montana",
        "NE": "Nebraska",
        "NV": "Nevada",
        "NH": "New Hampshire",
        "NJ": "New Jersey",
        "NM": "New Mexico",
        "NY": "New York",
        "NC": "North Carolina",
        "ND": "North Dakota",
        "OH": "Ohio",
        "OK": "Oklahoma",
        "OR": "Oregon",
        "PW": "Palau",
        "PA": "Pennsylvania",
        "PR": "Puerto Rico",
        "RI": "Rhode Island",
        "SC": "South Carolina",
        "SD": "South Dakota",
        "TN": "Tennessee",
        "TX": "Texas",
        "UT": "Utah",
        "VT": "Vermont",
        "VI": "Virgin Islands",
        "VA": "Virginia",
        "WA": "Washington",
        "WV": "West Virginia",
        "WI": "Wisconsin",
        "WY": "Wyoming"
      }
      return states[val];
    }
  })

  .filter('airbnbSlug', function(){
    return function(location){
      return _.kebabCase(location.city) + '--' + _.kebabCase(location.state);
    }
  })

  .filter('readableTerm', ['$filter', function($filter){
    return function(loan){
      if(loan.loan_type === 'HELOC'){
        return 'HELOC';
      }else if(loan.adjustable){
        var years = loan.arm_years_initial || 5;
        return years + '/1 ARM';
      }else{
        let termYears = $filter('roundedTermYears')(loan);
        return `${termYears} Year Fixed`;
      }
    }
  }])

  .filter('roundedTermYears', [function(){
    return function(loan){
      let termYears = loan.termYears || loan.termYearsEstimated;
      termYears = Math.round(termYears * 100) / 100; // display up to two decimals
      return termYears;
    }
  }])

  .filter('money',["$filter", function ($filter) {
    return function(amount){
      var currency = $filter('currency');

      if(amount < 0)
        return currency(amount, '$', 0).replace('(', '-').replace(')', '');

      return currency(amount, '$', 0);
    }
  }])

  .filter('pluralPhrase', function(){
    return function(length, str){
      // format is 'singular|plural'
      var options = str.split('|');

      if(length === 1) // singular
        return options[0];
      else // zero or plural
        return options[1];
    }
  })

  .filter('rentalQualityPhrase', function(){
    return function(percentage){
      if(percentage < .4) return 'a basic';
      if(percentage < .75) return 'a nice';

      return 'a fancy';
    }
  })

  .filter('notificationCopy', function(){
    var mapping = {
      'unverified_loans': 'We found loan info in public records for your home, but it\'s missing the interest rate. Confirm the details to make Homebot more accurate.',
      'no_loans': 'Do you have any loans? Homebot is more accurate when it knows your loans.',
      'refi_30': 'You may be able to do a 30-year refi with a lower rate, which could save a lot in the long run and lower your monthly payments.',
      'refi_15': 'Doing a 15-year refi could grow your wealth a lot faster. It may require a larger monthly payment, but you might be able to do it!',
      'reverse': 'You may qualify for a Reverse Mortgage to eliminate your mortgage payment and maybe even generate monthly income back to you!',
      'pmi': 'You are close to getting out of your mortgage insurance! This could be huge for you.',
      'pp_investment': 'You may have purchasing power for an investment property.',
      'pp_trade': 'It looks like you may have enough purchasing power to consider trading up to a new home!',
      'rental': 'Have you noticed how much wealth you could build by renting your home on Airbnb or VRBO?',
      'principal_pay': 'Pro tip: Even just a small additional monthly payment toward principal can often dramatically accelerate your wealth building.',
      'cash_out': 'You may have "cashout power" to do things like home improvement or high-interest debt consolidation.'
    }

    return function(verb){
      return mapping[verb];
    }
  })

  .filter('notificationAnchor', function(){
    var mapping = {
      'unverified_loans': 'loans',
      'refi_30': 'refi',
      'refi_15': 'refi',
      'reverse': 'reverse-mortgage',
      'pmi': 'pmi',
      'pp_investment': 'buying-power',
      'pp_trade': 'buying-power',
      'rental': 'nightly-rentals',
      'principal_pay': 'diy-refi',
      'cash_out': 'cashout',
      'no_loans': 'no-loans'
    }

    return function(verb){
      return mapping[verb];
    }
  })

  .filter('excludeAgentsNotFound', function(){
    return function(agents){
      return _.filter(agents, function(agent){
        try{
          return agent.datasources.rets.status === 'success';
        }catch(e){ return false; };
      });
    }
  });
